import React from 'react';
import UserPage from './UserPage/UserPage';

const User = () => {
    return (
        <div>
            <UserPage />
        </div>
    );
};

export default User;
